import { useState, useEffect, useRef } from 'react';
import { collection, query, onSnapshot, where, orderBy, limit } from 'firebase/firestore';
import { db } from '../index';

export function useCollection(path, filters = [], options = {}) {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  const filtersKey = String(filters.length);
  const unsubRef   = useRef(null);

  useEffect(() => {
    if (!path || typeof window === 'undefined' || !db) {
      setData([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const constraints = buildConstraints(filters);
    const q = query(collection(db, path), ...constraints);

    const unsub = onSnapshot(
      q,
      (snap) => {
        setData(snap.docs.map((d) => ({ id: d.id, ...d.data(), _docId: d.id })));
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    unsubRef.current = unsub;
    return () => unsub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, filtersKey]);

  if (options.raw) return { data, loading, error };
  return data;
}

function buildConstraints(filters) {
  return filters.map((f) => {
    if (typeof f === 'object' && f._type) return f;
    if (f.field && f.op) return where(f.field, f.op, f.value);
    if (f.orderBy) return orderBy(f.orderBy, f.direction || 'asc');
    if (f.limit)   return limit(f.limit);
    return f;
  });
}
